export default "__VITE_ASSET__9dPvcPw3__"